export const jumpToAnchor = () => {
  const { hash } = window.location;
  const id = hash.replace('#', '');
  const element = document.getElementById(id);

  if (element) {
    element.scrollIntoView();
  }
};
